var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09099 3.40899L5.5 4.99997M5.5 4.99997L3.90901 6.59096M5.5 4.99997L7.09099 6.59096M5.5 4.99997L3.90901 3.40899M10 2.18749L10 7.81251C10 8.74448 9.24448 9.5 8.3125 9.5H2.6875C1.75552 9.5 1 8.74448 1 7.81251V2.18749C1 1.25552 1.75552 0.5 2.6875 0.5H8.3125C9.24448 0.5 10 1.25552 10 2.18749Z",
    stroke: "#E82127",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveTransaction);
export default __webpack_public_path__ + "static/media/RemoveTransaction.e507a1ba4d4a8c967606ee767ff342f6.svg";
export { ForwardRef as ReactComponent };